// extracted by mini-css-extract-plugin
module.exports = {"viewport":"Slack_viewport__doL7Q","slackMobile":"Slack_slackMobile__v4oSw","content":"Slack_content__lJCXH"};